import { createRouter, createWebHistory } from 'vue-router';
import { authGuard } from '@/utils/navigationGuards';

const routes = [
  {
    path: '/',
    name: 'default',
    component: () => import('@/view/default.vue'),
    redirect: { name: 'login' },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('@/view/TheLogin.vue'),
        meta: { requiresGuest: true }
      },
      {
        path: 'cadastro',
        name: 'cadastro',
        component: () => import('@/view/TheCadastro.vue'),
        meta: { requiresGuest: true }
      },
      {
        path: 'completaCadastro',
        name: 'completarCadastro',
        component: () => import('@/view/CompletarCadastro.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'dashAlunos',
        name: 'dashAlunos',
        component: () => import('@/view/dashAlunos.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'AlunosViagens',
        name: 'AlunosViagens',
        component: () => import('@/view/Viagens.vue'),
        meta: { requiresAuth: true, shared: true }
      },
      {
        path: 'AlunosExcecaoRota',
        name: 'SolicitarExcecaoRota',
        component: () => import('@/view/SolicitarExcecaoRota.vue'),
        meta: { requiresAuth: true, shared: true }
      },
      {
        path: 'ChamadaRepresentante',
        name: 'ChamadaRepresentante',
        component: () => import('@/view/ChamadaRepresentante.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'RegistrarPagamentoRepresentante',
        name: 'RegistrarPagamentoRepresentante',
        component: () => import('@/view/RegistrarPagamentoRepresentante.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'GerarPassagemRepresentante',
        name: 'GerarPassagemRepresentante',
        component: () => import('@/view/GerarPassagemRepresentante.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'AlunosPerfil',
        name: 'AlunosPerfil',
        component: () => import('@/view/Perfil.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'Configuracoes',
        name: 'Configuracoes',
        component: () => import('@/view/Configuracoes.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'AlunosChamados',
        name: 'AlunosChamados',
        component: () => import('@/view/MeusChamados.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'dashAdmin',
        name: 'dashAdmin',
        component: () => import('@/view/dashAdmin.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminGestaoUsuarios',
        name: 'AdminGestaoUsuarios',
        component: () => import('@/view/GestaoUsuarios.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminGestaoDetalhe/:uid',
        name: 'AdminGestaoDetalhe',
        component: () => import('@/view/GestaoUsuarioDetalhe.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminGestaoRotas',
        name: 'AdminGestaoRotas',
        component: () => import('@/view/GestaoRotas.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminGestaoFrota',
        name: 'AdminGestaoFrota',
        component: () => import('@/view/GestaoFrota.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminGestaoMotoristas',
        name: 'AdminGestaoMotoristas',
        component: () => import('@/view/GestaoMotoristas.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminPlanejamentoDiario',
        name: 'AdminPlanejamentoDiario',
        component: () => import('@/view/AdminPlanejamentoDiario.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminChamada',
        name: 'AdminChamada',
        component: () => import('@/view/AdminChamada.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminExcecoesRota',
        name: 'AdminExcecoesRota',
        component: () => import('@/view/AdminExcecoesRota.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminGerarPassagem',
        name: 'AdminGerarPassagem',
        component: () => import('@/view/AdminGerarPassagem.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminPerfil',
        name: 'AdminPerfil',
        component: () => import('@/view/AdminPerfil.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminConfiguracoes',
        name: 'AdminConfiguracoes',
        component: () => import('@/view/AdminConfiguracoes.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminRelatorios',
        name: 'AdminRelatorios',
        component: () => import('@/view/AdminRelatorios.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminRelatorios/:tipo',
        name: 'AdminRelatorioDetalhe',
        component: () => import('@/view/AdminRelatorioDetalhe.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'aguardandoAprovacao',
        name: 'aguardandoAprovacao',
        component: () => import('@/view/AguardandoAprovacao.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'AdminAprovacaoCadastro',
        name: 'AdminAprovacaoCadastro',
        component: () => import('@/view/AdminAprovacaoCadastro.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminSuporte',
        name: 'AdminSuporte',
        component: () => import('@/view/AdminSuporte.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminLogs',
        name: 'AdminLogs',
        component: () => import('@/view/AdminLogs.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AdminPagamentos',
        name: 'AdminPagamentos',
        component: () => import('@/view/AdminPagamentos.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'AlunosPagamentos',
        name: 'AlunosPagamentos',
        component: () => import('@/view/AlunosPagamentos.vue'),
        meta: { requiresAuth: true, shared: true }
      },
      {
        path: 'Pagamento/:mensalidadeId',
        name: 'Pagamento',
        component: () => import('@/view/Pagamento.vue'),
        meta: { requiresAuth: true, shared: true }
      },
      {
        path: 'PagamentoSucesso',
        name: 'PagamentoSucesso',
        component: () => import('@/view/PagamentoSucesso.vue'),
        meta: { requiresAuth: true, shared: true }
      },
      {
        path: 'PagamentoFalha',
        name: 'PagamentoFalha',
        component: () => import('@/view/PagamentoFalha.vue'),
        meta: { requiresAuth: true, shared: true }
      },
      {
        path: 'Sobre',
        name: 'Sobre',
        component: () => import('@/view/SobreAerj.vue'),
        // shared: acessível tanto por aluno quanto por admin — sem essa
        // flag o authGuard redireciona qualquer admin pra dashAdmin, já
        // que por padrão uma rota com requiresAuth (sem requiresAdmin) é
        // assumida como exclusiva de aluno.
        meta: { requiresAuth: true, shared: true }
      }/*,
      {
        path: 'dashDev',
        name: 'dashDev',
        component: () => import('@/view/dashDev.vue'),
        meta: { requiresAuth: true, requiresDev: true }
      }*/
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    redirect: { name: 'login' }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(authGuard);

// Após um deploy, uma aba aberta ainda aponta para chunks (js/css) do build
// anterior, que não existem mais (404) — a tela lazy não abre e o clique
// "não faz nada". Recarrega uma vez para pegar o build novo; a flag evita
// loop de reload se o chunk estiver realmente indisponível.
router.onError((error, to) => {
  const msg = String(error?.message || error)
  const ehChunk = error?.name === 'ChunkLoadError'
    || /Loading (CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(msg)
  if (!ehChunk) return

  const chave = 'aerj_chunk_reload'
  try {
    if (sessionStorage.getItem(chave) === '1') return
    sessionStorage.setItem(chave, '1')
  } catch { /* sessionStorage indisponível: ainda tenta o reload uma vez */ }

  window.location.assign(to?.fullPath || window.location.href)
})

// Título da aba por tela — leitor de tela e histórico do navegador distinguem as páginas.
const TITULOS = {
  login: 'Entrar', cadastro: 'Criar conta', completarCadastro: 'Completar cadastro',
  aguardandoAprovacao: 'Cadastro em análise',
  dashAlunos: 'Início', AlunosViagens: 'Minhas viagens', SolicitarExcecaoRota: 'Exceção de rota',
  ChamadaRepresentante: 'Chamada', RegistrarPagamentoRepresentante: 'Registrar pagamento',
  GerarPassagemRepresentante: 'Passagem de passageiro', AlunosPerfil: 'Meu perfil',
  Configuracoes: 'Configurações', AlunosChamados: 'Meus chamados', AlunosPagamentos: 'Minhas mensalidades',
  Pagamento: 'Pagamento', PagamentoSucesso: 'Pagamento confirmado', PagamentoFalha: 'Pagamento não concluído',
  Sobre: 'Sobre a AERJ',
  dashAdmin: 'Painel', AdminGestaoUsuarios: 'Gestão de usuários', AdminGestaoDetalhe: 'Detalhe do usuário',
  AdminGestaoRotas: 'Rotas', AdminGestaoFrota: 'Frota', AdminGestaoMotoristas: 'Motoristas',
  AdminPlanejamentoDiario: 'Planejamento diário', AdminChamada: 'Chamada', AdminExcecoesRota: 'Exceções de rota',
  AdminGerarPassagem: 'Passagem de passageiro', AdminPerfil: 'Perfil', AdminConfiguracoes: 'Configurações',
  AdminRelatorios: 'Relatórios', AdminRelatorioDetalhe: 'Relatório', AdminAprovacaoCadastro: 'Aprovação de cadastros',
  AdminSuporte: 'Suporte', AdminLogs: 'Logs do sistema', AdminPagamentos: 'Financeiro',
}

// Navegação concluída = app carregou direito; libera nova recuperação futura.
router.afterEach((to) => {
  try { sessionStorage.removeItem('aerj_chunk_reload') } catch { /* ignore */ }
  const titulo = TITULOS[to.name]
  document.title = titulo ? `${titulo} · AERJ` : 'AERJ'
})

export default router;